// React
import { useEffect, useState } from "react"

// Types
import type { SuccessFetch } from "types"
import type { BuildType, FetchBuildType } from "../../types"

// Utils
import { useApi } from "utils"
import { default_option } from "pages/Purchase/utils"

export function useDetailByBuild(build_id: number): {
  data: BuildType | null
  isLoading: boolean
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<BuildType | null>(null)
  const [isLoading, setLoading] = useState<boolean>(true)

  useEffect(() => {
    api.get(
      "/list_build_item/detailbuilditem",
      { params: { build_id } }
    ).then((res: SuccessFetch<{
      payload: FetchBuildType[]
    }>) => {
      // Vars
      const payload = res.data.payload[0]
      const product = payload.product

      setData({
        ingredient: payload.ingredient.map(item => ({
          ...item,
          qty: Number(item.qty),
          soh: Number(item.soh)
        })),
        product: {
          ...product,
          employee_id: product.employee_id?.toString() ?? "",
          location_id: product.location_id.toString(),
          qty_build_unit: Number(product.qty_build_unit),
          approve_by: product.approve_by ?? "-",
          approve_status: default_option.find(item => item.value === product.approve_status.toString())?.label ?? "-",
        }
      })
      
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })

    return () => {
      setData(null)
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { data, isLoading }
}